import React from "react"

import { PrimitiveText } from "@/primitives/PrimitiveText"

import { TitleTextProps } from "@/components/Text/protocols"

import { SxProps, Theme } from "@mui/material"

import useStyles from "@/components/Text/Title/styles"
import { FONT } from "@/styles/fonts"

export const Title = (props: TitleTextProps) => {
	const {
		children,
		color,
		type,
		textTransform = "none",
		fontWeight = "regular",
		gutterBottom = false,
		sx
	} = props

	const classes = useStyles()

	const getTitleStyle = () => {
		const titleTypeToTitleStyle: Record<TitleTextProps["type"], SxProps<Theme>> = {
			h1: classes.h1,
			h2: classes.h2,
			h3: classes.h3
		}

		const titleStyle = titleTypeToTitleStyle[type]

		return titleStyle
	}

	return (
		<PrimitiveText
			sx={[{ color: color, fontWeight: FONT.fontWeight[fontWeight] }, getTitleStyle(), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps<Theme>}
			textTransform={textTransform}
			gutterBottom={gutterBottom}
		>
			{children}
		</PrimitiveText>
	)
}